import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Switch from "@mui/material/Switch";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {useDefaultQuoteSettingsContext} from "../../contexts/DefaultQuoteSettingsContext";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const DefaultSettingsAcqFee = ({ }) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { quoteSettings, setSettingsStateWithUpdate } = useDefaultQuoteSettingsContext()

    return (
        <TableRow
            key={'Acq Fee'}
            sx={{
                '&:last-child td, &:last-child th': {border: 0},
                height: '10px',
                background: '#F0F6FA'
            }}
            className={'default-settings-fee'}
        >

            <TableCell
                className={'DealPageFee fee-name'}
                scope="row"
                size={'small'}
                width={'60%'}
                align="left"
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: "row",
                        alignItems: 'center',
                        // justifyContent: 'space-between',
                    }}
                >
                    Acquisition Fee
                    {/*<InfoOutlinedIcon*/}
                    {/*    sx={{*/}
                    {/*        fontSize: '19px',*/}
                    {/*        marginLeft: '5px'*/}
                    {/*    }}*/}
                    {/*/>*/}
                </div>
            </TableCell>
            {
                !isTabletOrMobile &&
                <React.Fragment>
                    <TableCell
                        className={'DealPageFee'}
                        align="right"
                        size={'small'}
                        width={'20%'}
                    >
                    </TableCell>
                    <TableCell
                        className={'DealPageFee'}
                        align="right"
                        size={'small'}
                        width={'20%'}
                    >
                        <Switch
                            checked={quoteSettings.is_acq_fee_capped}
                            onChange={() => {
                                setSettingsStateWithUpdate({is_acq_fee_capped: !quoteSettings.is_acq_fee_capped}, true)
                            }}
                        />
                    </TableCell>
                </React.Fragment>
            }
            <TableCell
                align="right"
                size={'small'}
                className={'DealPageFee'}
                width={'60%'}
                sx={{ fontStyle: 'italic'}}
            >
                Calculated
            </TableCell>
        </TableRow>
    )
}